import React from 'react';

interface ButtonProps {
  classes?: string;
  tooltip?: string;
  labelActive?: any;
  labelInactive?: any;
  value: any;
  onChangeHandler: any;
  disabled: boolean;
}

const SliderCheckbox = ({
  classes,
  tooltip,
  value,
  onChangeHandler,
  labelActive = 'Ja',
  labelInactive = 'Nein',
  disabled = false,
}: ButtonProps) => {
  const onChange = () => {
    onChangeHandler(!value);
  };
  return (
    <label className={'switch ' + classes ?? ''} title={tooltip ?? ''}>
      <input
        type='checkbox'
        checked={value}
        onChange={onChange}
        disabled={disabled}
      />
      <span className='slider round'>
        <span className='sliderdot'>{value ? labelActive : labelInactive}</span>
      </span>
    </label>
  );
};

export default SliderCheckbox;
